module.exports = require("tslib");


//////////////////
// WEBPACK FOOTER
// external "tslib"
// module id = 1
// module chunks = 0 1